export const ROOT_URL = 'https://api.openweathermap.org'
export const API_KEY = '7ddf1b21b7810e441e45b026c4042a19' // stored here only for test project purpose
